<template>
  <div class="dict">
    <el-form :model="formData" :rules="rules" ref="formData" label-width="100px">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="5">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('inventoryTransfer.form.title') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundNo')">
                  <el-input
                    style="width: 100%"
                    v-model="formData.allotNo"
                    :disabled="true"
                    :placeholder="this.$t('inventoryTransfer.form.outboundNoPlaceholder')"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundCreatePerson')">
                  <el-input
                    style="width: 100%"
                    v-model="formData.allotCreatePersonName"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundStatus')">
                  <el-input
                    style="width: 100%"
                    v-model="requestStatusData[formData.allotStatus - 1]"
                    :disabled="true"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  style="width: 100%"
                  :label="this.$t('inventoryTransfer.form.companyName')"
                  prop="allotCompanyNo"
                >
                  <el-select
                    v-model="formData.allotCompanyNo"
                    @change="(val) => handleChange(val, 'allotCompanyNo')"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in JSON.parse(userInfo.userInfo.companyList)"
                      :key="item.personCompanyCode"
                      :label="item.personCompanyName"
                      :value="item.personCompanyCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.departmentName')">
                  <!--获取后端数据渲染的下拉框-->
                  <ajax-select
                    style="width: 100%"
                    v-model="formData.allotDepartmentNo"
                    :placeholder="$t('search.choose')"
                    :apiUrl="apiUrl"
                    :apiData="{
                      id: userInfo.userInfo.userCode,
                      userCode: userInfo.userInfo.userCode,
                      personName: userInfo.userInfo.userName,
                      personCompanyCode: formData.allotCompanyNo,
                    }"
                    :multiple="false"
                    :clearable="true"
                    :dataString="'data.personDepartmentInfo'"
                    :valueKey="'personDepartmentCode'"
                    :labelKey="'personDepartmentName'"
                    :valueType="'string'"
                    @change="(val) => handleChange(val, 'allotDepartmentNo')"
                  ></ajax-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundCreateDate')">
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.allotCreateDate"
                    :disabled="true"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                    <el-form-item :label='this.$t("inventoryTransfer.form.allotDate")'>
                         <el-date-picker style="width:100%" v-model="formData.allotDate"  :disabled=true
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd" >
                        </el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col :span="6">
                    <el-form-item :label='this.$t("inventoryTransfer.form.outboundPrintTime")'>
                         <el-date-picker  style="width:100%" :disabled=true
                            :placeholder='this.$t("inventoryTransfer.form.outboundPrintTimePlaceholder")'
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd" >
                        </el-date-picker>
                    </el-form-item>
                    </el-col> -->
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>{{ this.$t('inventoryTransfer.form.info') }}
            </div>
          </template>
          <div class="collapse-content">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.outboundPrintTime')">
                  <el-date-picker
                    style="width: 100%"
                    :disabled="true"
                    :placeholder="this.$t('inventoryTransfer.form.outboundPrintTimePlaceholder')"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 调出方式 -->
              <el-col :span="6">
                <el-form-item prop="outIsDirectDeliver" label="调出方式">
                  <el-select
                    style="width: 100%"
                    v-model="formData.outIsDirectDeliver"
                    :disabled="canEdit"
                    @change="isDirectDeliverChange"
                    clearable
                    filterable
                  >
                    <el-option label="直拨" value="1"></el-option>
                    <el-option label="非直拨" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 调入方式 -->
              <el-col :span="6">
                <el-form-item prop="inIsDirectDeliver" label="调入方式">
                  <el-select
                    style="width: 100%"
                    v-model="formData.inIsDirectDeliver"
                    :disabled="canEdit"
                    @change="isDirectDeliverChange"
                    clearable
                    filterable
                  >
                    <el-option label="直拨" value="1"></el-option>
                    <el-option label="非直拨" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 调出仓库 -->
              <el-col :span="6">
                <el-form-item
                  prop="allotOutStorage"
                  :label="this.$t('inventoryTransfer.form.outboundStorageNo')"
                >
                  <SearchModal
                    ref="searchModalOut"
                    propName="storageName"
                    propCode="storageCode"
                    className="customer-search"
                    model="allotOutStorage"
                    :placeholder="this.$t('inventoryTransfer.form.outboundStorageNoPlaceholder')"
                    :API="storage.API"
                    :query="storage.query"
                    :page="storage.page"
                    :searchColumns="storage.searchColumns"
                    :isMultiple="true"
                    :columnList="storage.columnList"
                    :currentValue="formData.allotOutStorage"
                    @setSearchModal="setWareHouseOut"
                  ></SearchModal>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotInStorage"
                  :label="this.$t('inventoryTransfer.form.inboundStorageNo')"
                >
                  <SearchModal
                    ref="searchModalIn"
                    propName="storageName"
                    propCode="storageCode"
                    model="allotInStorage"
                    className="customer-search"
                    :placeholder="this.$t('inventoryTransfer.form.outboundStorageNoPlaceholder')"
                    :API="storage.API"
                    :query="storage.query"
                    :page="storage.page"
                    :searchColumns="storage.searchColumns"
                    :isMultiple="true"
                    :columnList="storage.columnList"
                    :currentValue="formData.allotInStorage"
                    @setSearchModal="setWareHouseIn"
                  ></SearchModal>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="this.$t('inventoryTransfer.form.contactPerson')">
                  <el-input
                    style="width: 100%"
                    v-model="formData.nameVoyageLicense"
                    :disabled="canEdit"
                    :placeholder="this.$t('inventoryTransfer.form.contactPersonPlaceholder')"
                    clearable
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotDate"
                  :label="this.$t('inventoryTransfer.form.outboundCreateTime')"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.allotDate"
                    :disabled="canEdit"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :placeholder="this.$t('inventoryTransfer.form.outboundCreateTimePlaceholder')"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  prop="allotType"
                  :label="this.$t('inventoryTransfer.form.outboundType')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.allotType"
                    :disabled="canEdit"
                    :placeholder="this.$t('inventoryTransfer.form.outboundTypePlaceholder')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in allotTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item
                  prop="allotMethod"
                  :label="this.$t('inventoryTransfer.form.deliveryMethod')"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.allotMethod"
                    :disabled="canEdit"
                    filterable
                    :placeholder="this.$t('inventoryTransfer.form.deliveryMethodPlaceholder')"
                    clearable
                  >
                    <el-option
                      v-for="item in deliveryTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>
                <el-form-item
                  prop="deliveryNote"
                  :label="this.$t('inventoryTransfer.form.deliveryNote')"
                >
                  <el-input
                    style="width: 100%"
                    v-model="formData.allotMark"
                    :disabled="canEdit"
                    :placeholder="this.$t('inventoryTransfer.form.deliveryNotePlaceholder')"
                    type="textarea"
                    :rows="3"
                    clearable
                    maxlength="256"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <el-collapse v-model="activeNames" class="collapse-main-content collapse-last-content">
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('inventoryTransfer.form.goodInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="goodTable"
              class="vxe-table-element"
              size="mini"
              align="center"
              :auto-resize="true"
              :data="rowData.goodTable"
              :toolbar="tableToolbar"
              :edit-rules="goodRules"
              @cell-click="(val) => rowClick(val, 'goodTable')"
              :edit-config="editConfig"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-slot:buttons>
                <vxe-button
                  :disabled="canEdit"
                  size="medium"
                  icon="el-icon-delete"
                  class="vxe-btn-delete"
                  @click="handleDelete('goodTable')"
                  >删除</vxe-button
                >
                <vxe-button
                  :disabled="canEdit"
                  size="medium"
                  class="vxe-btn-primary"
                  @click="addRow('goodTable')"
                  >添加更多行记录</vxe-button
                >
              </template>
              <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
              <vxe-table-column
                type="index"
                width="60"
                :title="$t('table.index')"
              ></vxe-table-column>
              <vxe-table-column
                field="preAllotBatchNo"
                width="200"
                :title="$t('inventoryTransfer.form.good.businessInboundBatchNo')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <SearchTable
                    v-model="row.batchNo"
                    searchType="inboundNewNo"
                    :isMultiple="true"
                    :currentValue="row.preAllotBatchNo || null"
                    :extraData="{
                      storageNo: formData.allotOutStorageNo,
                      batchDepartmentNo: formData.allotDepartmentNo,
                      companyCode: formData.allotCompanyNo,
                      availableIsMoreZero: 1,
                    }"
                    @input="(val) => setInboundNo(val, row)"
                  ></SearchTable>
                  <!-- <SearchModal
                    width="900"
                    ref="searchModal"
                    propName="businessInboundBatchNo"
                    propCode="businessInboundBatchNo"
                    model="productCode"
                    className="customer-search"
                    :placeholder="
                      $t('inventoryTransfer.form.good.businessInboundBatchNoPlaceholder')
                    "
                    :API="inboundList.API"
                    :query="inboundList.query"
                    :searchColumns="inboundList.searchColumns"
                    :page="true"
                    :isMultiple="true"
                    :currentValue="row.preAllotBatchNo"
                    :columnList="inboundList.columnList"
                    :extraData="{
                      storageNo: formData.allotOutStorageNo,
                      batchDepartmentNo: formData.allotDepartmentNo,
                      companyCode: formData.allotCompanyNo,
                      availableIsMoreZero: 1,
                    }"
                    @setSearchModal="(val, select) => setInboundNo(val, select, row)"
                  ></SearchModal> -->
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="proAllotBatchNo"
                width="160"
                :title="$t('inventoryTransfer.form.good.outboundBatchNo')"
              >
              </vxe-table-column>
              <vxe-table-column
                field="contractNo"
                width="160"
                :title="$t('inventoryTransfer.form.good.contractNo')"
              >
              </vxe-table-column>
              <vxe-table-column
                field="projectNo"
                width="160"
                :title="$t('inventoryTransfer.form.good.projectNo')"
              >
              </vxe-table-column>
              <!-- <vxe-table-column
                field="settleBatchNewNo"
                width="160"
                :title="$t('inventoryTransfer.form.good.settlendBatchNo')"
              /> -->
              <vxe-table-column
                field="distributionBatchNo"
                width="100"
                :title="$t('inventoryTransfer.form.good.distributionBatchNo')"
              />
              <vxe-table-column
                field="productDetailNo"
                width="160"
                :title="$t('inventoryTransfer.form.good.productNo')"
              />
              <vxe-table-column
                field="productName"
                width="160"
                :title="$t('inventoryTransfer.form.good.productName')"
              />
              <vxe-table-column
                field="partnerName"
                width="160"
                :title="$t('inventoryTransfer.form.good.suppiler')"
              />
              <vxe-table-column
                field="allotUnitName"
                width="160"
                :title="$t('inventoryTransfer.form.good.productUnit')"
              />
              <vxe-table-column :title="$t('inventoryTransfer.form.good.businessOrder')">
                <vxe-table-column
                  field="allotOutAmount"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.businessOrderQuantity')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      v-model="row.allotOutAmount"
                      :max="row.availableNum"
                      :precision="$globalVar.qPoint"
                      @input="(val) => changeAmount(val, row)"
                    ></input-number-ad>
                  </template>
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.allotOutAmount, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  width="160"
                  :title="$t('inventoryTransfer.form.good.businessOrderPackage')"
                  field="allotOutPackage"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      v-model="row.allotOutPackage"
                      :max="999999999.999999"
                      :precision="$globalVar.qPoint"
                      @input="(val) => changePackage(val)"
                    ></input-number-ad>
                  </template>
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.allotOutPackage, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="confirmAllotOutAmount"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.ensureOutQuantity')"
                >
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.confirmAllotOutAmount, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="confirmAllotOutPackage"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.ensureOutPackage')"
                >
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.confirmAllotOutPackage, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="actualAllotOutAmount"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.logisticsOutQuantity')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      v-model="row.actualAllotOutAmount"
                      :disabled="true"
                      :precision="$globalVar.qPoint"
                    ></input-number-ad>
                  </template>
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.actualAllotOutAmount, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="actualAllotOutPackage"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.logisticsOutPackage')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      v-model="row.actualAllotOutPackage"
                      :disabled="true"
                      :precision="$globalVar.qPoint"
                    ></input-number-ad>
                  </template>
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.actualAllotOutPackage, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
              </vxe-table-column>
              <vxe-table-column :title="$t('inventoryTransfer.form.good.storageShouldSend')">
                <!-- 物流已入库数量 -->
                <vxe-table-column
                  field="allotInAmount"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.storageShouldSendQuantity')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      v-model="row.allotInAmount"
                      :disabled="true"
                      :precision="$globalVar.qPoint"
                    ></input-number-ad>
                  </template>
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.allotInAmount, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="allotInPackage"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.storageShouldSendPackage')"
                  :edit-render="{ name: 'input' }"
                >
                  <template v-slot:edit="{ row }">
                    <input-number-ad
                      v-model="row.allotInPackage"
                      :disabled="true"
                      :precision="$globalVar.qPoint"
                    ></input-number-ad>
                  </template>
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.allotInPackage, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <!-- 确认掉入数量 -->
                <vxe-table-column
                  field="confirmAllotInAmount"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.storageSendQuantity')"
                >
                  <!-- <template v-slot:edit="{ row }">
                                    <input-number-ad
                                        v-model="row.confirmAllotInAmount"
                                        @input="(val) => changeConfirmAmount(val)"
                                        :max ="parseFloat(row.allotOutAmount)&&parseFloat(row.allotInAmount)?Number(row.allotOutAmount)>Number(row.allotInAmount)?row.allotOutAmount:row.allotInAmount:row.allotOutAmount||row.allotInAmount"
                                        :precision="$globalVar.qPoint"
                                    ></input-number-ad>
                                </template> -->
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.confirmAllotInAmount, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  field="confirmAllotInPackage"
                  width="160"
                  :title="$t('inventoryTransfer.form.good.storageSendPackage')"
                >
                  <!-- <template v-slot:edit="{ row }">
                                    <input-number-ad
                                        v-model="row.confirmAllotInPackage"
                                        @input="(val) => changeConfirmPackage(val)"
                                        :max ="parseFloat(row.allotOutPackage)&&parseFloat(row.allotInPackage)?Number(row.allotOutPackage)>Number(row.allotInPackage)?row.allotOutPackage:row.allotInPackage:row.allotOutPackage||row.allotInPackage"
                                        :precision="$globalVar.qPoint"
                                    ></input-number-ad>
                                </template> -->
                  <template v-slot="{ row }">{{
                    $baseRequest.formatTableColumn(row.confirmAllotInPackage, $globalVar.qPoint)
                  }}</template>
                </vxe-table-column>
              </vxe-table-column>
              <vxe-table-column field="businessAllotUnitPrice" width="160" title="单价">
                <template v-slot="scope">
                  {{
                    $baseRequest.formatTableColumn(
                      scope.row.businessAllotUnitPrice,
                      $globalVar.pPoint
                    ) || 0
                  }}
                </template>
              </vxe-table-column>
              <vxe-table-column field="businessAllotTotalPrice" width="160" title="金额">
                <template v-slot="scope">
                  {{ $baseRequest.formatTableColumn(scope.row.businessAllotTotalPrice) || 0 }}
                </template>
              </vxe-table-column>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('inventoryTransfer.form.transportInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-form :model="formData" :rules="rules" label-width="100px">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item
                  prop="shippingMethod"
                  :label="this.$t('inventoryTransfer.form.shippingMethod')"
                  label-width="70px"
                >
                  <el-select
                    style="width: 100%"
                    v-model="formData.deliveryMethod"
                    :disabled="canEdit"
                    :clearable="true"
                    filterable
                    :placeholder="this.$t('inventoryTransfer.form.shippingMethodPlaceholder')"
                  >
                    <el-option
                      v-for="item in deliveryMethodList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!-- 运输信息表格 -->
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="transportTable"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="rowData.transportTable"
              :toolbar="tableToolbar"
              :edit-config="editConfig"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-slot:buttons>
                <vxe-button
                  :disabled="canEdit"
                  size="medium"
                  icon="el-icon-delete"
                  class="vxe-btn-delete"
                  @click="handleDelete('transportTable')"
                  >删除</vxe-button
                >
                <vxe-button
                  :disabled="canEdit"
                  size="medium"
                  class="vxe-btn-primary"
                  @click="addRow('transportTable')"
                  >添加更多行记录</vxe-button
                >
              </template>
              <vxe-table-column type="checkbox" width="60"></vxe-table-column>
              <vxe-table-column
                type="index"
                width="60"
                :title="$t('table.index')"
              ></vxe-table-column>
              <vxe-table-column
                field="nameVoyageLicense"
                :title="$t('inventoryTransfer.form.transport.nameVoyageLicense')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input
                    v-model="row.nameVoyageLicense"
                    maxlength="32"
                    clearable
                  ></el-input> </template
              ></vxe-table-column>
              <vxe-table-column
                field="freightInformation"
                :title="$t('inventoryTransfer.form.transport.freightInformation')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.freightInformation" maxlength="32" clearable></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="contactPerson"
                :title="$t('inventoryTransfer.form.transport.contactPerson')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.contactPerson" maxlength="32" clearable></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="contactPhoneNo"
                :title="$t('inventoryTransfer.form.transport.contactPhoneNo')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.contactPhoneNo" maxlength="32" clearable></el-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="identityCardNumber"
                :title="$t('inventoryTransfer.form.transport.identityCardNumber')"
                :edit-render="{ name: 'input' }"
              >
                <template v-slot:edit="{ row }">
                  <el-input v-model="row.identityCardNumber" maxlength="32" clearable></el-input>
                </template>
              </vxe-table-column>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>

      <el-collapse-item name="5">
        <!--上传附件-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ $t('salesBill.title.uploadFile') }}
          </div>
        </template>
        <div class="collapse-content">
          <div>
            <upload
              ref="upload"
              :isShow="!canEdit"
              defaultPath="scm/inventoryTransfer"
              :tableData="attachmentList"
              @upload="uploadList"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 保存 -->
      <el-button type="primary" @click="save" :loading="load" class="fixed-bottom-btn"
        >保存</el-button
      >
      <el-button type="primary" @click="commit" :loading="load" class="fixed-bottom-btn"
        >提交审批</el-button
      >
      <el-button
        v-if="this.formData.allotNo && this.formData.allotStatus == '1'"
        type="danger"
        @click="del()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <el-button
        v-if="this.formData.allotStatus == '3'"
        type="primary"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >撤回</el-button
      >
      <!-- <el-button v-if="this.formData.allotStatus!='0'" type="primary" @click="saveTransport" :loading="load" class="fixed-bottom-btn">{{$t('inventoryTransfer.btnList.transportRequst')}}</el-button> -->
      <el-button
        v-if="this.formData.outboundStatus == '3'"
        type="primary"
        @click="confirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('inventoryTransfer.btnList.effectConfirm') }}</el-button
      >
      <el-button
        v-if="formData.allotStatus == '5'"
        type="primary"
        @click="doReverse"
        :loading="load"
        class="fixed-bottom-btn"
        >冲销</el-button
      >
    </div>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import DataBaseAPI from '@/api/dataBase';
  import formRules from './rules/rules';
  // import column from './columns/columns';
  import API from '@/api/wareHouse/inventoryTransfer';
  import ajaxSelect from '@/components/form-item/ajax-select';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import BASE_API from '@/api/dataBase.js';
  import upload from '@/components/upload';
  import XEUtils from 'xe-utils';
  export default {
    components: {
      SearchModal,
      inputNumberAd,
      ajaxSelect,
      upload,
    },
    name: 'inventoryTransferBaseEdit',
    data() {
      let newDate = new Date();
      return {
        attachmentList: [],
        requestStatusData: ['已保存', '审批中', '调拨中', '已撤销', '调拨完成', '已冲销'],
        load: false,
        canEdit: false,
        rules: formRules.formRules,
        flag: this.$route.query.flag,
        allotTypeList: [],
        deliveryMethodList: [],
        deliveryTypeList: [],
        goodRules: formRules.goodRules,
        tableToolbar: {},
        editConfig: { trigger: 'click', mode: 'row' },
        activeNames: ['1', '2', '3', '4', '5'], //默认展开那些面板，
        formData: {
          allotStatus: 1,
          allotDate: newDate,
          allotOutStorage: '',
          allotInStorage: '',
          allotType: 'DB01',
          allotMethod: 'DBFS01',
          outIsDirectDeliver: '0',
          inIsDirectDeliver: '0',
        },
        rowData: {
          goodTable: [],
          transportTable: [],
        },
        rowIndex: {
          goodTable: 0,
          transportTable: 0,
        },
        storageNo: null, //出库仓库
        apiUrl: BASE_API.GET_PERSON_API,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //仓库
      storage() {
        return {
          propName: 'storageName', // 输入框展示内容
          propCode: 'storageCode',
          query: {
            storageCode: '',
            storageName: '',
            adminFlag: this.userInfo.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              prop: 'storageCode',
              name: this.$t('warehouse.search.warehouseCode'),
              type: 'input',
              placeholder: this.$t('warehouse.search.warehouseCodePlaceholder'),
            },
            {
              prop: 'storageName',
              name: this.$t('warehouse.search.warehouseName'),
              type: 'input',
              placeholder: this.$t('warehouse.search.warehouseNamePlaceholder'),
            },
          ],
          API: DataBaseAPI.STORAGE_LIST_API,
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
            {
              prop: 'storageCompanyCode',
              label: this.$t('warehouse.table.createWarehouseCompanyCode'),
            },
            {
              prop: 'storageCompanyName',
              label: this.$t('warehouse.table.createWarehouseCompanyName'),
            },
            {
              prop: 'personName',
              label: this.$t('warehouse.table.gmtCreateBy'),
            },
            {
              prop: 'storageCreateTime',
              label: this.$t('warehouse.table.gmtCreate'),
            },
            // { prop: "currentStatus", label: this.$t("warehouse.table.status") }
          ],
        };
      },
      row() {
        return {
          goodTable: {
            tenantCode: this.userInfo.userInfo.tenantCode,
            companyCode: this.userInfo.userInfo.companyCode,
            departmentCode: this.userInfo.userInfo.departmentCode,
            companyName: this.userInfo.userInfo.companyName,
            departmentName: this.userInfo.userInfo.departmentName,
            preAllotBatchNo: '',
            productDetailNo: '',
            productName: '',
            partnerNo: '',
            partnerName: '',
            allotUnit: '',
            allotOutAmount: '',
            allotOutPackage: '',
            businessAllotUnitPrice: '',
            businessAllotTotalPrice: 0,
            availableNum: 0,
            distributionBatchNo: '', //物流批次号
          },
          transportTable: {
            tenantCode: this.userInfo.userInfo.tenantCode,
            companyCode: this.userInfo.userInfo.companyCode,
            departmentCode: this.userInfo.userInfo.departmentCode,
            companyName: this.userInfo.userInfo.companyName,
            departmentName: this.userInfo.userInfo.departmentName,
            deliveryType: '',
            nameVoyageLicense: '',
            freightInformation: '',
            contactPerson: '',
            contactPhoneNo: '',
            identityCardNumber: '',
          },
        };
      },
      //业务入库批次
      inboundList() {
        return {
          width: '900',
          query: {
            tenantCode: this.userInfo.userInfo.tenantCode,
            companyCode: this.formData.allotCompanyNo,
            batchDepartmentNo: this.formData.allotDepartmentNo,
            inboundStatus: '02',
            nameVoyageLicense: null,
            productName: null,
            startGmtCreate: null,
            endGmtCreate: null,
            contractInternalNo: null,
            batchNo: null,
            storageName: null,
            partnerName: null,
            marineLadingNo: null,
            warehouseReceiptsNo: null,
            settleBatchNo: null,
            productDetailNo: null,
            distributionBatchNo: '',
          },
          API: API.LIST_INBOUND,
          searchColumns: [
            {
              prop: 'productName',
              name: this.$t('businessReceiptList.search.productName'),
              type: 'input',
            },
            {
              prop: 'startGmtCreate',
              name: this.$t('businessReceiptList.search.startGmtCreate'),
              type: 'startDaterangePicker',
            },
            {
              prop: 'endGmtCreate',
              name: this.$t('businessReceiptList.search.endGmtCreate'),
              type: 'endDaterangePicker',
            },
            {
              prop: 'contractInternalNo',
              name: this.$t('businessReceiptList.search.contractInternalNo'),
              type: 'input',
            },
            {
              prop: 'batchNo',
              name: this.$t('businessReceiptList.search.batchNo'),
              type: 'input',
            },
            {
              prop: 'storageName',
              name: this.$t('businessReceiptList.search.storageName'),
              type: 'input',
            },
            {
              prop: 'partnerName',
              name: this.$t('businessReceiptList.search.partnerName'),
              type: 'input',
            },
            {
              prop: 'marineLadingNo',
              name: this.$t('businessReceiptList.search.marineLadingNo'),
              type: 'input',
            },
            {
              prop: 'warehouseReceiptsNo',
              name: this.$t('businessReceiptList.search.warehouseReceiptsNo'),
              type: 'input',
            },
            {
              prop: 'settleBatchNo',
              name: this.$t('businessReceiptList.search.settleBatchNo'),
              type: 'input',
            },
            {
              prop: 'productDetailNo',
              name: this.$t('businessReceiptList.search.productDetailNo'),
              type: 'input',
            },
            {
              prop: 'nameVoyageLicense',
              name: this.$t('payablesBillList.form.good.nameVoyageLicense'),
              type: 'input',
            },
            {
              type: 'input',
              prop: 'distributionBatchNo',
              name: this.$t('logistics.commodityMarket.distributionBatchNo'),
            },
          ],
          columnList: [
            {
              prop: 'batchNo',
              label: this.$t('businessReceiptList.search.incomingBatch'),
              fixed: 'left',
              width: 140,
            },
            {
              prop: 'storageQuantity',
              label: this.$t('businessReceiptList.table.storageQuantity'),
              fixed: 'left',
              width: 100,
            },
            {
              prop: 'availableQuantity',
              label: '可用库存数量',
              fixed: 'left',
              width: 100,
            },
            {
              prop: 'storageName',
              label: this.$t('businessReceiptList.search.storageName'),
            },
            {
              prop: 'productName',
              label: this.$t('businessReceiptList.search.productName'),
              width: 120,
            },
            {
              prop: 'gmtCreate',
              label: this.$t('businessReceiptList.table.gmtCreate'),
            },
            {
              prop: 'inboundNo',
              label: this.$t('businessReceiptList.table.inboundNo'),
            },
            {
              prop: 'contractInternalNo',
              label: this.$t('businessReceiptList.search.contractInternalNo'),
            },
            {
              prop: 'businessUnitPriceWithTax',
              label: this.$t('businessReceiptList.table.businessUnitPriceWithTax'),
            },
            {
              prop: 'financeUnitPriceWithTax',
              label: this.$t('businessReceiptList.table.financeUnitPriceWithTax'),
            },
            {
              prop: 'partnerName',
              label: this.$t('businessReceiptList.search.partnerName'),
            },
            {
              prop: 'marineLadingNo',
              label: this.$t('businessReceiptList.search.marineLadingNo'),
            },
            {
              prop: 'warehouseReceiptsNo',
              label: this.$t('businessReceiptList.search.warehouseReceiptsNo'),
            },
            {
              prop: 'settleBatchNo',
              label: this.$t('businessReceiptList.search.settleBatchNo'),
            },
            {
              prop: 'nameVoyageLicense',
              label: this.$t('payablesBillList.form.good.nameVoyageLicense'),
            },
            {
              prop: 'distributionBatchNo',
              label: this.$t('logistics.commodityMarket.distributionBatchNo'),
            },
          ],
        };
      },
    },
    mounted() {
      let userInfo = this.userInfo.userInfo;
      this.formData.allotCreatePersonName = userInfo.userName;
      this.formData.allotCreatePersonNo = userInfo.userCode;
      this.formData.allotCompanyNo = null;
      this.formData.allotCompanyName = null;
      this.formData.allotDepartmentNo = null;
      this.formData.allotDepartmentName = null;
      this.formData.allotCreateDate = new Date();
      this.formData.allotDate = new Date();
      this.formData.companyCode = userInfo.companyCode;
      this.formData.companyName = userInfo.companyName;
      this.formData.departmentCode = userInfo.departmentCode;
      this.formData.departmentName = userInfo.departmentName;
      this.getDic();
      this.getDepartmentList();
      //控制页面是否可修改
      if (this.$route.query && this.$route.query.id) {
        this.getData(this.$route.query.id);
      }
      if (this.$route.name == 'inventoryTransferAdd' && !XEUtils.isEmpty(this.$route.query)) {
        // 结算批次跳转过后初始化界面
        let data = this.$route.query;
        this.formData.allotOutStorage = data.allotOutStorage;
        this.formData.allotOutStorageNo = data.allotOutStorageNo;
        this.rowData.goodTable = JSON.parse(data.storageAllotDetailVOs);
      }
    },
    methods: {
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //调拨类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'allot_type',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.allotTypeList = res.data.data;
            }
          });
        //调拨方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'allocation_method',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.deliveryTypeList = res.data.data;
            }
          });
        //运输方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'delivery_method',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.deliveryMethodList = res.data.data;
            }
          });
      },
      // 获取当前登录人所在的部门
      getDepartmentList() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.formData.allotCompanyNo,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //选中塞值
      handleChange(val, prop) {
        if (prop == 'allotCompanyNo') {
          let companyObj = JSON.parse(this.userInfo.userInfo.companyList).find(
            (i) => i.personCompanyCode === val
          );
          this.formData.allotCompanyNo = val;
          this.formData.allotCompanyName = companyObj ? companyObj.personCompanyName : '';
          this.formData.allotDepartmentNo = null;
          this.formData.allotDepartmentName = null;
          this.rowData.goodTable = [];
        } else if (prop == 'allotDepartmentNo') {
          this.formData.allotDepartmentNo = val;
          this.formData.allotDepartmentName = this.departmentList.find((item) => {
            return item.personDepartmentCode == val;
          }).personDepartmentName;
          this.rowData.goodTable = [];
        }
        this.$forceUpdate();
      },
      //查询详情
      getData(id) {
        this.$axios.get(API.DETAIL_API, { allotNo: id }).then((res) => {
          if (res.data.code === 0) {
            this.formData = res.data.data;
            this.attachmentList = res.data.data.attachmentList;
            this.rowData.goodTable = this.formData.storageAllotDetailVOs;
            if (this.rowData.goodTable && this.rowData.goodTable.length > 0) {
              this.rowData.goodTable.map((item) => {
                // item.availableNum =item.surplusQuantity
                let params = {
                  batchNo: item.preAllotBatchNo,
                };
                this.$axios.post(API.LIST_INBOUND, params).then((res) => {
                  if (res.data.code === 0) {
                    item.availableNum = res.data.data[0].storageQuantity;
                    return item;
                  }
                });
              });
            }
            this.rowData.transportTable = this.formData.distributionAllotTransportVOs;
          }
        });
      },
      //类型
      isDirectDeliverChange() {
        this.$refs.searchModalOut.blurModal();
        this.$refs.searchModalIn.blurModal();
        this.formData.allotOutStorageNo = null;
        this.formData.allotOutStorage = null;
        this.formData.allotInStorage = null;
        this.formData.allotInStorageNo = null;
        this.storageNo = null;
        this.rowData.goodTable = [];
      },
      //选择出库仓库
      setWareHouseOut(val, row) {
        if (row.length > 0 && this.formData.allotOutStorageNo != row[0].storageCode) {
          this.formData.allotOutStorageNo = row[0].storageCode;
          this.formData.allotOutStorage = row[0].storageName;
          this.storageNo = row[0].storageCode;
          this.rowData.goodTable = [];
        }
      },
      //选择入库仓库
      setWareHouseIn(val, row) {
        if (row.length > 0) {
          this.formData.allotInStorageNo = row[0].storageCode;
          this.formData.allotInStorage = row[0].storageName;
        }
      },
      //点击表格记录正在编辑哪一行
      rowClick(value, type) {
        this.rowIndex[type] = value.$rowIndex;
      },
      //选择业务入库批次
      setInboundNo(value, row) {
        console.log(value, row);
        if (value && value.length > 0) {
          this.rowData.goodTable[this.rowIndex.goodTable].preAllotBatchNo = value[0].batchNo;
          this.rowData.goodTable[this.rowIndex.goodTable].productDetailNo =
            value[0].productDetailNo;
          this.rowData.goodTable[this.rowIndex.goodTable].productName = value[0].productName;
          this.rowData.goodTable[this.rowIndex.goodTable].partnerNo = value[0].partnerNo;
          this.rowData.goodTable[this.rowIndex.goodTable].partnerName = value[0].partnerName;
          this.rowData.goodTable[this.rowIndex.goodTable].allotUnit = value[0].productUnit;
          this.rowData.goodTable[this.rowIndex.goodTable].allotUnitName = value[0].productUnitName;
          //this.rowData.goodTable[this.rowIndex.goodTable].businessAllotUnitPrice = value[0].businessContractPrice
          this.rowData.goodTable[this.rowIndex.goodTable].businessAllotUnitPrice =
            value[0].businessUnitPriceWithTax || value[0].businessContractPrice || 0;
          //this.rowData.goodTable[this.rowIndex.goodTable].exchangeRate = value[0].taxRate
          //this.rowData.goodTable[this.rowIndex.goodTable].currencyTypeCode =value[0].currencyTypeCode
          //this.rowData.goodTable[this.rowIndex.goodTable].currencyTypeName =value[0].currencyTypeName
          this.rowData.goodTable[this.rowIndex.goodTable].availableNum = value[0].storageQuantity;
          this.rowData.goodTable[this.rowIndex.goodTable].contractNo = value[0].contractInternalNo;
          this.rowData.goodTable[this.rowIndex.goodTable].contractDetailNo =
            value[0].contractInternalDetailNo;
          this.rowData.goodTable[this.rowIndex.goodTable].distributionBatchNo =
            value[0].distributionBatchNo; //物流批次
        }
      },
      //修改数量
      changeAmount(val) {
        //确认调出数量赋值为业务调出数量
        if (this.formData.outIsDirectDeliver == 1) {
          this.rowData.goodTable[this.rowIndex.goodTable].confirmAllotOutAmount = val;
        }
        this.rowData.goodTable[this.rowIndex.goodTable].confirmAllotInAmount = val;
        this.rowData.goodTable[this.rowIndex.goodTable].allotOutAmount = val;
        let params = {
          returnQuantity: val,
          returnUnitPrice: this.rowData.goodTable[this.rowIndex.goodTable].businessAllotUnitPrice,
        };
        if (params.returnQuantity && params.returnUnitPrice) {
          this.$axios.post(API.GET_AMOUNT, params).then((res) => {
            if (res.data.code === 0) {
              this.rowData.goodTable[this.rowIndex.goodTable].businessAllotTotalPrice = Number(
                res.data.data.returnMoneyAmount
              ).toFixed(6);
            }
          });
        }
      },
      //修改件数
      changePackage(val) {
        this.rowData.goodTable[this.rowIndex.goodTable].allotOutPackage = val;
        this.rowData.goodTable[this.rowIndex.goodTable].confirmAllotInPackage = val;
      },
      //确认调入数量
      changeConfirmAmount(val) {
        this.rowData.goodTable[this.rowIndex.goodTable].confirmAllotInAmount = val;
      },
      //确认调入件数
      changeConfirmPackage(val) {
        this.rowData.goodTable[this.rowIndex.goodTable].confirmAllotInPackage = val;
      },

      //新增行
      addRow(type) {
        if (type == 'goodTable' && !this.formData.allotOutStorageNo) {
          this.$message({
            showClose: true,
            message: this.$t('inventoryTransfer.msg.selectWareHouse'),
            type: 'error',
          });
          return;
        }
        this.rowData[type].push(JSON.parse(JSON.stringify(this.row[type])));
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
            this.rowData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancle'),
            });
          });
      },
      //保存/提交
      save() {
        this.saveData(1);
      },
      //提交
      commit() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            //判断商品数量
            if (!(this.rowData.goodTable && this.rowData.goodTable.length > 0)) {
              this.$message({
                showClose: true,
                message: this.$t('inventoryTransfer.msg.goodNeedMsg'),
                type: 'error',
              });
              return;
            } else {
              this.$refs.goodTable.validate((valid) => {
                if (valid) {
                  this.saveData(2);
                }
              });
            }
          }
        });
      },
      //提交数据
      saveData(status) {
        this.load = true;
        let data = this.formData;
        if (this.$route.query && this.$route.query.id) {
          //data.id = this.$route.query.id
          data.isAdd = false;
        } else {
          data.isAdd = true;
        }
        if (status == 1) {
          data.isSubmit = false;
        } else {
          data.isSubmit = true;
        }
        data.currencyTypeCode = 'CNY';
        data.currencyTypeName = '人民币';
        let userInfo = this.userInfo.userInfo;
        data.tenantCode = userInfo.tenantCode;
        //物流运输信息
        let transportList = [];
        if (this.rowData.transportTable && this.rowData.transportTable.length > 0) {
          this.rowData.transportTable.map((item, index) => {
            item.allotDetailNo = index + 1;
          });
          transportList = this.rowData.transportTable;
        }
        //商品信息
        let goodList = [];
        if (this.rowData.goodTable && this.rowData.goodTable.length > 0) {
          this.rowData.goodTable.map((item, index) => {
            item.allotDetailNo = index + 1;
          });
          goodList = this.rowData.goodTable;
        }
        // ===========sunxueping TAPD[ID1000844]需求增加批次号查重校验逻辑===========
        let batchNoList = goodList.map((item) => {
          return item.preAllotBatchNo;
        });
        if (batchNoList.length > Array.from(new Set(batchNoList)).length) {
          return this.$message({
            showClose: true,
            message: '不同行项目不可重复同一批次号（相同批次号只能在一行）',
            type: 'error',
          });
        }
        // =========================================================================
        data.distributionAllotTransportDTOs = transportList;
        data.storageAllotDetailDTOs = goodList;
        data.attachmentList = XEUtils.clone(this.attachmentList, true);
        this.loading.startLoading();
        let url = status === 2 ? API.SUBMIT_API : API.SAVE_API;
        this.$axios
          .post(url, data)
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.load = false;
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              if (status == 1) {
                if (this.$route.name == 'inventoryTransferAdd') {
                  this.dblclickEvent(res.data.data);
                } else {
                  this.getData(res.data.data.allotNo);
                }
              } else {
                this.toPath();
              }
            } else {
              this.load = false;
              if (status === 2) {
                if (res.data.data) {
                  if (this.$route.name == 'inventoryTransferAdd') {
                    this.dblclickEvent(res.data.data);
                  } else {
                    this.getData(res.data.data.allotNo);
                  }
                }
              }
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => this.loading.endLoading());
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/wareHouse/inventoryTransferAdd',
            name: 'inventoryTransferAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/inventoryTransferDetail',
            name: 'inventoryTransferDetail',
            meta: {
              keepAlive: false,
            },
            query: { id: value.allotNo },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      toPath() {
        let path = {
          fromPath: {
            path: '/wareHouse/inventoryTransferAdd',
            name: 'inventoryTransferAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/inventoryTransferList',
            name: 'inventoryTransferList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //保存物流运输单
      saveTransport() {
        let data = {};
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        data.deliveryCreatePersonName = this.basicData.returnOperatorName;
        data.deliveryCreatePersonNo = this.basicData.returnOperatorNo;
        data.deliveryLoginCompany = this.userInfo.userInfo.companyName;
        data.deliveryType = '4';
        data.otherNo = this.basicData.returnNo;
        data.providerNo = this.basicData.partnerCode;
        data.providerName = this.basicData.partnerName;
        data.salesmanNo = this.basicData.returnSalesmanNo;
        data.salesmanName = this.basicData.returnSalesmanName;
        data.deliveryDepartment = this.userInfo.userInfo.departmentName;
        data.pickupStorageNo = this.basicData.outboundStorageCode;
        data.pickupStorageName = this.basicData.outboundStorageName;
        // data.shiptoStorageName = warehouseName;
        data.deliveryStatus = 1;
        let productList = [];
        // deliveryDetailStr.map((item, index) => {
        //   let obj = {
        //     other_no: index + 1,
        //     providerNo: this.basicData.partnerCode,
        //     providerName: this.basicData.partnerName,
        //     productNo: item.productCode,
        //     productName: item.productName,
        //     deliveryQuantity: item.returnQuantity,
        //     contractUnit: item.unit,
        //   };
        //   productList.push(obj);
        // });
        data.deliveryDetailStr = JSON.stringify(productList);
        this.$axios.post(API.SAVE_DELIVERY, data).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      // 撤回
      async doWithdraw() {
        let params = {
          //撤回所需参数
          allotNo: this.formData.allotNo,
          version: this.formData.version,
        };
        this.$baseRequest
          .doWithdrawCommon(API.REVOKE_API, params)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: res.msg,
              });
              this.getData(this.$route.query.id);
            } else {
              this.$message({ showClose: true, type: 'error', message: res.msg });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      },
      // 冲销
      async doReverse() {
        let params = {
          allotNo: this.formData.allotNo,
          version: this.formData.version,
        };
        let res = await this.$axios.post(API.REVERSE_API, params);
        if (res) {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.getData(this.$route.query.id);
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      //生效确认
      confirm() {
        //物流已入库数量不等于业务确认调入数量  confirmAllotInAmount
        const list =
          this.rowData.goodTable.filter((item) => {
            return item.confirmAllotInAmount != item.allotInAmount;
          }) || [];
        if (list.length > 0) {
          this.$confirmAction('提示', this.$t('businessReceiptList.message.sureConfirm'))
            .then(() => {
              //  this.sureConfirm();
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.cancel'),
              });
            });
        } else {
          //    this.sureConfirm();
        }
      },
      sureConfirm() {
        let params = {
          allotNo: this.formData.allotNo,
          version: this.formData.version,
        };
        this.$axios.post(API.CONFIRM_API, params).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      del() {
        // sxp add TAPD-ID1001775 20210318
        this.$confirmAction()
          .then(() => {
            this.load = true;
            this.$axios.post(API.DEL_API, { allotNo: this.formData.allotNo }).then((res) => {
              this.load = false;
              if (res.data.code == 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.toPath();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },

      //更新附件列表
      uploadList(value) {
        this.attachmentList = [];
        if (value.length) {
          value.map((item) => {
            this.attachmentList.push({
              ...item,
            });
          });
        }
      },
    },
    watch: {},
  };
</script>
<style lang="scss" scoped>
  .deliveryOrderTop {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 26px 10px 11px 10px;
  }
  .collapse-last-content {
    margin-top: 10px;
  }
</style>
